/* eslint-disable */
import { Delete } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as R from 'ramda';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }
import moment from 'moment';

import DataTable from 'react-data-table-component';
import Select from 'react-select'

import Spinner from 'components/Spinner.js';

const typeMap = {
  'BIN_TO_BIN          ': 'Bin to Bin Transfer',
  'CREATE_PO           ': 'Create PO',
  'TRANSACTION         ': 'Transaction',
  'RECEIVE_PO          ': 'Receive PO',
  'SINGLE_RECEIVE_PO   ': 'Receive PO',
  'SCJ                 ': 'Stock Count Job',
  'TRANSFER            ': 'Transfer',
};

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

function formatErrorMessage(message)
{
  var start = message.search("Error Description") > 0 ? message.search("Error Description") : 0;
  //var end = message.search("Node Identifier") > 0 ? message.search("Node Identifier") : message.length;
  var end = message.search("<ta") > 0 ? message.search("<ta") : message.length;
  var formattedMessage = message.substring(start, end);

  formattedMessage = <Fragment>
    <Typography color="inherit">{formattedMessage.split('\n')[0]}</Typography>
      <ul>
        {formattedMessage.split('\n').map((l, i) => l.trim().length > 0 && i > 0 ? <li>{l}</li> : null)}
      </ul>
    </Fragment>;
  return formattedMessage;
}

function getColumns(onArchiveCB, finished)
{
  const columns = [
    {
        name: 'Type',
        selector: row => typeMap[row.stage_type],
        sortable: true,
    },
    {
      name: 'Reference Code',
      selector: row => row.reference_code,
      sortable: true,
    },
  ]

  const unfinishedColumns = 
  [
    {
      name: 'Sync Time',
      selector: row => moment(row.run_time).format('YYYY/MM/D HH:mm:ss'),
      sortable: true,
    },
    {
      name: 'Status',
      //selector: row => row.status,
      cell: row => {
        return <HtmlTooltip title={row.status.trim() == 'ERROR' && row.message && row.message.length > 0 ? 
          formatErrorMessage(row.message)
          : ''}>
            <span>{row.status}</span>
          </HtmlTooltip>
      },
      sortable: true,
    },
    {
      name: 'Remove',
      cell: row => {
        return <Button color="default" onClick={() => onArchiveCB(row)}><Delete/></Button>
      },
      sortable: false,
    },
  ];

  const finishedColumns = 
  [
    {
      name: 'Sync Time',
      selector: row => moment(row.sync_time).format('YYYY/MM/D HH:mm:ss'),
      sortable: true,
    },
    {
      name: 'Batch No.',
      selector: row => row.batch_no,
      sortable: true,
    },
    {
      name: 'Document No.',
      selector: row => row.doc_no,
      sortable: true,
    },
  ]

  return finished ? R.concat(columns, finishedColumns) : R.concat(columns, unfinishedColumns);
}

export default class SyncList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: true,
      showSelect: false,
      disableSync: false,
      finished: false,
      data: []
    };
  }

  componentDidMount() {
    this.refreshList();
  }

  refreshList = () => {
    this.setState({
      showSpinner: true,
    });
    var $this = this;
    fetch(`/api/shared/stagings/${this.state.finished ? 'finished' : 'queued'}/list`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            data: data.data.stagings,
            showSpinner: false,
            showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  doSync = (onlyGP) => {
    this.setState({
      disableSync: true,
      showSpinner: true,
    });
    var $this = this;
    fetch(`/api/shared/stagings/${onlyGP ? 'pullPOs' : 'pullAll'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            showSpinner: false,
            disableSync: false,
          }, alert('Sync successful.'));
        }
        else {
          $this.setState({
            showSpinner: false,
            disableSync: false,
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false,
          disableSync: false,
        });
        alert('There was an error. Please try again later.')
      });
  }

  runNow = (row) => {
    if (this.state.finished)
      return;

    if (!confirm(`Set ${typeMap[row.stage_type]} "${row.reference_code}" to run now?`))
      return;

    this.setState({
      showSpinner: true,
    });

    var $this = this;
    fetch(`/api/shared/stagings/runNow`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ stageId: row.id})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          this.refreshList();
          alert('Update successful.')
        }
        else {
          $this.setState({
            showSpinner: false,
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false,
        });
        alert('There was an error. Please try again later.')
      });
  }

  archive = (row) => {
    //alert(`Row ${row.id} clicked!`); return;
    if (!confirm(`Remove ${typeMap[row.stage_type]} "${row.reference_code}"?`))
      return;

    this.setState({
      showSpinner: true,
    });

    var $this = this;
    fetch(`/api/shared/stagings/archive`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ stageId: row.id})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          this.refreshList();
          alert('Update successful.')
        }
        else {
          $this.setState({
            showSpinner: false,
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false,
        });
        alert('There was an error. Please try again later.')
      });
  }

  handleChangeView = () => {
    this.setState({ finished: !this.state.finished}, () => this.refreshList())
  }

  render ()
  {
    var $this = this;
    return (
      <Fragment>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        <a href="#" onClick={this.refreshList}>Refresh</a>
        { this.state.showTable ?
        <DataTable
              columns={getColumns(this.archive, this.state.finished)}
              data={this.state.data}
              keyField='id'
              onRowClicked={r => this.runNow(r)}
              striped
              highlightOnHover
              pointerOnHover
              dense
              pagination
          />
          : ""
        }<br/>
        {this.state.disableSync ?
          <Fragment>
            <Button variant="contained" color="primary" disabled>Pull POs from GP</Button>&nbsp;&nbsp;
            <Button variant="contained" color="primary" disabled>Pull all from GP</Button>&nbsp;&nbsp;
            <Button variant="contained" color="secondary" onClick={this.handleChangeView}>
              Show {this.state.finished ? 'Queued' : 'Recent Finished'}</Button>&nbsp;&nbsp;
          </Fragment>
        :
          <Fragment>
            <Button variant="contained" color="primary" onClick={() => $this.doSync(true)}>Pull POs from GP</Button>&nbsp;&nbsp;
            <Button variant="contained" color="primary" onClick={() => $this.doSync(false)}>Pull all from GP</Button>&nbsp;&nbsp;
            <Button variant="contained" color="primary" onClick={this.handleChangeView}>
              Show {this.state.finished ? 'Queued' : 'Recent Finished'}</Button>&nbsp;&nbsp;
          </Fragment>
        }
      </Fragment>
    );
  }
}
